<template>
  <v-container class="px-0">
    <v-row justify="center" no-gutters>
      <v-col md="1">
        <check-upload-csv
          class="w-100"
          groupFileName="material"
          :switchValue="showFirstComponentMapeamento"
          :fileWasUploaded="materialFileWasUploaded"
          @CsvSentDeleted="clearInfoCsv($event)"
        />
      </v-col>
      <v-col md="4">
        <p
          class="center-text-switch-laudo-incremental currentSwitchLabel"
          :class="showFirstComponentMapeamento ? 'primary-color-text' : ''"
        >
          Enviar arquivo por material
        </p>
      </v-col>
      <v-col md="2" class="container-switch-laudo-incremental">
        <v-switch
          id="switch-banco-precos-csv"
          v-model="switchUpload"
          class="switch-laudo-incremental"
          @change="showFirstComponentMapeamento = !showFirstComponentMapeamento"
        />
      </v-col>
      <v-col md="4">
        <p
          class="c-switch-estim center-text-switch-laudo-incremental currentSwitchLabel"
          :class="!showFirstComponentMapeamento ? 'primary-color-text' : ''"
        >
          Enviar arquivo por tucagem
        </p>
      </v-col>
      <v-col md="1" class="text-right">
        <check-upload-csv
          class="w-100"
          groupFileName="tucagem"
          :switchValue="!showFirstComponentMapeamento"
          :fileWasUploaded="tucagemFileWasUploaded"
          @CsvSentDeleted="clearInfoCsv($event)"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-container class="card-switch-laudo-incremental-vnr pa-0">
          <v-scroll-x-reverse-transition hide-on-leave>
            <v-container v-show="showFirstComponentMapeamento" class="pa-0">
              <div class="currentSwitchLabel pt-3 text-center title-card-switch-laudo-incremental">Arquivo por Material</div>
              <mapeamento-arquivo
                ref="refMapeamentoMaterial"
                class="mt-0 pt-0"
                :camposMapeamento="infoUploadedFileMaterial.mapeamento"
                :camposObrigatorios="infoUploadedFileMaterial.camposObrigatorios"
                :required="materialFileWasUploaded"
                :preloadItems="needToUploadFakeFileMaterial"
                :functionDownloadArquivoModelo="() => downloadArquivoModelo('material')"
                :loadingArquivoModelo="loadingnDownloadArquivoModelo"
                @change="infoUploadedFileMaterial = $event"
                @preLoadingItemsReleased="fillFieldsCsv('material')"
                @clearActionTriggered="clearInfoCsv('material')"
              />
            </v-container>
          </v-scroll-x-reverse-transition>
          <v-scroll-x-transition hide-on-leave>
            <v-container v-show="!showFirstComponentMapeamento" class="pa-0">
              <div class="currentSwitchLabel pt-3 text-center title-card-switch-laudo-incremental">Arquivo por Tucagem</div>
              <mapeamento-arquivo
                ref="refMapeamentoTucagem"
                class="mt-0 pt-0"
                :camposMapeamento="infoUploadedFileTucagem.mapeamento"
                :camposObrigatorios="infoUploadedFileTucagem.camposObrigatorios"
                :required="tucagemFileWasUploaded"
                :preloadItems="needToUploadFakeFileTucagem"
                :functionDownloadArquivoModelo="() => downloadArquivoModelo('tucagem')"
                :loadingArquivoModelo="loadingnDownloadArquivoModelo"
                @change="infoUploadedFileTucagem = $event"
                @preLoadingItemsReleased="fillFieldsCsv('tucagem')"
                @clearActionTriggered="clearInfoCsv('tucagem')"
              />
            </v-container>
          </v-scroll-x-transition>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';

  export default {
    components: {
      MapeamentoArquivo: () => import('@/components/general/GeneralMapeamentoArquivo.vue'),
      CheckUploadCsv: () => import('@/components/simulacoesLaudosIncrementais/CheckUploadCsv.vue')
    },

    emits: ['fileClear'],

    data: () => ({
      switchUpload: false,
      showFirstComponentMapeamento: true,
      materialFileFound: false,
      loadingnDownloadArquivoModelo: false
    }),

    computed: {
      infoUploadedFileMaterial: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.infoUploadedFileMaterial;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { infoUploadedFileMaterial: value });
        }
      },
      infoUploadedFileTucagem: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.infoUploadedFileTucagem;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { infoUploadedFileTucagem: value });
        }
      },
      bancoPrecosMateriais: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.bancoPrecosMateriais;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { bancoPrecosMateriais: value });
        }
      },
      bancoPrecosTucagens: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.bancoPrecosTucagens;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { bancoPrecosTucagens: value });
        }
      },
      needToUploadFakeFileMaterial: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.infoUploadedFileMaterial.needToUploadFakeFile;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { infoUploadedFileMaterial: { needToUploadFakeFile: value } });
        }
      },
      needToUploadFakeFileTucagem: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.infoUploadedFileTucagem.needToUploadFakeFile;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { infoUploadedFileTucagem: { needToUploadFakeFile: value } });
        }
      },

      materialFileWasUploaded() {
        /* Verifica se foi feito upload de algum arquivo de Material */
        return this.infoUploadedFileMaterial.id ? true : false;
      },

      tucagemFileWasUploaded() {
        /* Verifica se foi feito upload de algum arquivo de Tucagem */
        return this.infoUploadedFileTucagem.id ? true : false;
      }
    },

    methods: {
      fillFieldsCsv(name) {
        if (this.bancoPrecosMateriais && name == 'material') {
          let variables = this.infoUploadedFileMaterial;
          this.$refs.refMapeamentoMaterial.fillFieldsCsv(
            variables.id,
            variables.delimitador,
            variables.involucro,
            variables.escape,
            variables.mapeamento
          );
          this.materialFileFound = true;
          this.showFirstComponentMapeamento = true;
          this.needToUploadFakeFileMaterial = false;
        }

        if (this.bancoPrecosTucagens && name == 'tucagem') {
          let variables = this.infoUploadedFileTucagem;
          this.$refs.refMapeamentoTucagem.fillFieldsCsv(
            variables.id,
            variables.delimitador,
            variables.involucro,
            variables.escape,
            variables.mapeamento
          );
          this.switchUpload = this.materialFileFound ? false : true;
          this.showFirstComponentMapeamento = this.materialFileFound ? true : false;
          this.needToUploadFakeFileTucagem = false;
        }
      },

      clearInfoCsv(nomeArquivo) {
        if (nomeArquivo == 'material') {
          this.infoUploadedFileMaterial = {
            id: null,
            delimitador: null,
            involucro: null,
            escape: null,
            mapeamento: { CODIGO_MATERIAL: '', VALOR_UNITARIO: '' }
          };
          this.$refs.refMapeamentoMaterial.clearComponentData(this.infoUploadedFileMaterial.mapeamento);
          this.bancoPrecosMateriais = false;
          this.$emit('fileClear', 'material');
        } else {
          // this.camposLocais.mapeamentoTucagem = {"TUC": "", "A1": "", "A2": "", "A3": "", "A4": "", "A5": "", "A6": "", "VALOR_UNITARIO": ""};
          this.infoUploadedFileTucagem = {
            id: null,
            delimitador: null,
            involucro: null,
            escape: null,
            mapeamento: { TUC: '', A1: '', A2: '', A3: '', A4: '', A5: '', A6: '', VALOR_UNITARIO: '' }
          };
          this.$refs.refMapeamentoTucagem.clearComponentData(this.infoUploadedFileTucagem.mapeamento);
          this.bancoPrecosTucagens = false;
          this.$emit('fileClear', 'tucagem');
        }
      },

      downloadArquivoModelo(tipo) {
        this.loadingnDownloadArquivoModelo = true;

        SimulacoesLaudosIncrementaisService.baixarArquivoModelo(tipo)
          .then(async (res) => {
            this.$toast.info('Processando...', '', { position: 'topRight', timeout: 1500 });

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `arquivo_modelo_${tipo}.csv`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => (this.loadingnDownloadArquivoModelo = false));
      }
    },

    watch: {
      materialFileWasUploaded(value) {
        this.bancoPrecosMateriais = value;
      },

      tucagemFileWasUploaded(value) {
        this.bancoPrecosTucagens = value;
      }
    }
  };
</script>
  
<style>
  .w-100 {
    height: 100% !important;
  }
  .currentSwitchLabel {
    color: rgba(0, 0, 0, 0.3);
    line-height: 1;
    min-height: 8px;
    font-size: 14px;
    white-space: pre-line !important;
  }
  .primary-color-text {
    color: #e5502c !important;
  }
  .card-switch-laudo-incremental-vnr {
    border-radius: 6px;
    box-shadow:
      0px 0px 0px rgba(0, 0, 0, 0.5),
      0px 0px 11px -5px rgba(0, 0, 0, 0.5);
  }
  .title-card-switch-laudo-incremental {
    color: #e5502c !important;
    font-size: 15px !important;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em;
  }
  .center-text-switch-laudo-incremental {
    height: 100% !important;
    display: flex;
    align-items: center;
  }
  .container-switch-laudo-incremental {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .switch-laudo-incremental {
    margin-top: 17px !important;
  }
  .switch-laudo-incremental .v-input--selection-controls__input .v-input--switch__thumb {
    color: #e5502c !important;
  }
  @media screen and (max-width: 958px) {
    .c-switch-estim {
      padding-left: 16px !important;
    }
  }
  @media screen and (max-width: 680px) {
    .c-switch-estim {
      padding-left: 10px !important;
    }
  }
</style>